"use strict";

import React, {useContext} from 'react';
import AccountEcheckList from "./AccountEcheckList";
import Icon from "../../component/Icon";
import {useHistory} from "react-router-dom";
import AccountEcheckProvider from "../provider/AccountEcheckProvider";
import {AccountEcheckConsumer} from "../context/AccountEcheckContext";

const AccountEchecks = (props) => {
    const history = useHistory();

    function handleNewEcheckClick(e){
        e.preventDefault();
        history.push('/echeck/accounts/echecks/create');
    }

    return (
        <React.Fragment>
            <h3>E-Checks</h3>
            <p>
                <a href="#" title="Create a new echeck" onClick={handleNewEcheckClick} className="btn__primary btn--small" >
                    <Icon name="add" /> New E-Check
                </a>
            </p>
            <AccountEcheckProvider>
                <AccountEcheckConsumer>
                    {({echecks=[], isFetchingEchecks=false, revokeEcheck=()=>{}})=> (
                        <AccountEcheckList echecks={echecks} isFetchingEchecks={isFetchingEchecks} onRevokeEcheck={revokeEcheck} />
                    )}
                </AccountEcheckConsumer>
            </AccountEcheckProvider>
        </React.Fragment>
    );
};

export default AccountEchecks;
